import { useMemo } from "react"
import messages from "../../messages/en.json"

type MessageTree = Record<string, unknown>
type TranslationValues = Record<string, string | number>

const catalog = messages as MessageTree

function readMessage(path: string): string | undefined {
  let current: unknown = catalog
  for (const segment of path.split(".")) {
    if (typeof current !== "object" || current === null || !(segment in current)) return undefined
    current = Reflect.get(current, segment)
  }
  return typeof current === "string" ? current : undefined
}

export function useTranslations(namespace?: string) {
  return useMemo(() => {
    return (key: string, values?: TranslationValues): string => {
      const path = namespace ? `${namespace}.${key}` : key
      const template = readMessage(path) ?? key
      if (!values) return template
      return template.replace(/\{(\w+)\}/g, (match, name: string) => {
        const value = values[name]
        return value === undefined ? match : String(value)
      })
    }
  }, [namespace])
}
